import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { FAVOURITE_ONBOARDING_STEPS } from '../../../mobile/components/OnboardingLayer/onboardingSteps';

var FavouritesUnlocked = /*#__PURE__*/function (_Component) {
  _inherits(FavouritesUnlocked, _Component);

  var _super = _createSuper(FavouritesUnlocked);

  function FavouritesUnlocked() {
    var _this;

    _classCallCheck(this, FavouritesUnlocked);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this._buttonHandler = function () {
      var _this$props = _this.props,
          dismissModal = _this$props.dismissModal,
          setOnboardingStep = _this$props.setOnboardingStep;
      dismissModal();
      setOnboardingStep(FAVOURITE_ONBOARDING_STEPS.FINISH);
      Logger.sendEvent(EVENT_TYPES.TUTORIAL_STARTED, {
        id: ONBOARDING_FLOWS.FAVOURITES
      });
      Logger.sendEvent(EVENT_TYPES.TUTORIAL_STEP_COMPLETE, {
        id: ONBOARDING_FLOWS.FAVOURITES,
        step: 1
      });
    };

    return _this;
  }

  _createClass(FavouritesUnlocked, [{
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render({
        buttonHandler: this._buttonHandler
      });
    }
  }]);

  return FavouritesUnlocked;
}(Component);

export { FavouritesUnlocked as default };